import React from 'react'
import { SubcontractorRequests } from 'src/components/subcontractor-request/SubcontractorRequests'
import { ReloadWrapper } from 'src/components/wrapper/reload-wrapper/ReloadWrapper'

export const SubcontractorRequestsPage = () => {
  return (
    <ReloadWrapper>
      <div data-testid="dashboard-requests-page">
        <SubcontractorRequests />
      </div>
    </ReloadWrapper>
  )
}
